import { render, staticRenderFns } from "./RamsAttendee.vue?vue&type=template&id=397c7035&"
import script from "./RamsAttendee.vue?vue&type=script&lang=js&"
export * from "./RamsAttendee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports